import { render } from "./ShowSecteur.vue?vue&type=template&id=2667cd58"
import script from "./ShowSecteur.vue?vue&type=script&lang=js"
export * from "./ShowSecteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__